import { useEffect, useState } from 'react';
import { EXIT_BLACK_LINES, EXIT_BLACKOUT_HOLD_MS } from '../shot/stadiumCinematic';
import { useTunnelExitStore } from './tunnelExitStore';
import './exit-black-monologue.css';

/**
 * Cinematic quote blocks on the tunnel→shot black screen,
 * timed with the exit voice-over.
 */
export function ExitBlackMonologue() {
  const beat = useTunnelExitStore((s) => s.beat);
  const active = beat === 'fade';
  const [lineState, setLineState] = useState<Record<number, 'on' | 'faded'>>(
    {},
  );
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!active) {
      setLineState({});
      setLeaving(false);
      return;
    }

    const timers: number[] = [];
    setLeaving(false);
    setLineState({});

    EXIT_BLACK_LINES.forEach((line, i) => {
      const at = line.atMs + EXIT_BLACKOUT_HOLD_MS;
      timers.push(
        window.setTimeout(() => {
          setLineState((v) => {
            const next: Record<number, 'on' | 'faded'> = { ...v, [i]: 'on' };
            for (let p = 0; p < i; p++) next[p] = 'faded';
            return next;
          });
        }, at),
      );
    });

    // Soft exit slightly before ShotAim so there's no empty black after text
    const last = EXIT_BLACK_LINES[EXIT_BLACK_LINES.length - 1];
    const fadeAt = last.atMs + EXIT_BLACKOUT_HOLD_MS + last.holdMs - 450;
    timers.push(
      window.setTimeout(() => setLeaving(true), Math.max(0, fadeAt)),
    );

    return () => timers.forEach((id) => window.clearTimeout(id));
  }, [active]);

  if (!active) return null;

  return (
    <div
      className={`exit-mono${leaving ? ' is-leaving' : ''}`}
      aria-live="polite"
    >
      <div className="exit-mono__stage">
        {EXIT_BLACK_LINES.map((line, i) => (
          <p
            key={line.text}
            className={[
              'exit-mono__line',
              i === EXIT_BLACK_LINES.length - 1 ? 'exit-mono__line--final' : '',
              lineState[i] === 'on'
                ? 'is-on'
                : lineState[i] === 'faded'
                  ? 'is-faded'
                  : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <span className="exit-mono__block">{line.text}</span>
          </p>
        ))}
      </div>
    </div>
  );
}
